import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { links } from "../data/link";
import { FaTimes } from "react-icons/fa";
import styled from "styled-components";
import { Context, ContextProvider } from "../context/Context";
import logo from "../Logo/Your_paragraph_text__2_-removebg-preview.png";
const Sidebar = () => {
  const { issidebarOpen, closeSidebar } = useContext(Context);
  return (
    <SidebarContainer>
      <aside
        className={`${issidebarOpen ? "sidebar show-sidebar " : "sidebar"}`}
      >
        <div className="sidebar-header">
          <Link to="/" onClick={closeSidebar}>
            <img src={logo} alt="LoveLease logo" className="logo"></img>
          </Link>

         {issidebarOpen && <button className="close-btn" type="button" onClick={closeSidebar}>
            <FaTimes />
          </button>}
        </div>
        <ul className="links">
          {links.map((link) => {
            return (
              <li key={link.id}>
                <Link to={link.url} onClick={closeSidebar}>
                  {link.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </aside>
    </SidebarContainer>
  );
};
export default Sidebar;

const SidebarContainer = styled.div`
  text-align: center;
  .sidebar-header {
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 1rem 1.5rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  img {
    height: 47px;
    width: 230px;
    border-radius: 0.5rem;
    background: white;
    padding: 0px 12px;
    margin-top: 8px;
  }
  .close-btn {
    font-size: 2rem;
    background: transparent;
    border-color: transparent;
    color: red;
    transition: var(--transition);
    cursor: pointer;
    margin-top: 0.2rem;
  }
  .close-btn:hover {
    color: var(--clr-red-light);
  }
  .links {
    margin-bottom: 2rem;
    list-style-type: none;
  }
  .links a {
    display: block;
    text-align: left;
    font-size: 1rem;
    text-transform: capitalize;
    text-decoration: none;
    padding: 1rem 1.5rem;
    color: var(--clr-grey-3);
    transition: var(--transition);
    letter-spacing: var(--spacing);
  }

  .links a:hover {
    padding: 1rem 1.5rem;
    padding-left: 2rem;
    background: var(--clr-grey-10);
    color: var(--clr-grey-2);
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--clr-white);
    transition: var(--transition);
    transform: translate(-100%);
    z-index: -1;
  }
  .show-sidebar {
    transform: translate(0);
    z-index: 999;
  }
  @media screen and (min-width: 992px) {
    .sidebar {
      display: none;
    }
  }
`;
